import React, { useState, createContext, useContext } from 'react'
import { HubConnectionBuilder } from '@microsoft/signalr';
import { decodeJwtWithJsrs } from "../../utils/helpers";
const ADAPTERS_BASE_URL = process.env.REACT_APP_ADAPTERS_BASE_URL;
const INTEGRATORS_BASE_URL = process.env.REACT_APP_API_INTEGRATOR_URL;
interface AdapterProviderProps {
    children: React.ReactNode
}

export const AdapterContext = createContext<any>(null);

export const useHub = () => {
    return useContext(AdapterContext)
}

export const AdapterProvider = ({ children }: AdapterProviderProps) => {
    const [signalRData, setSignalRData] = useState<any>([]);

    const makeSignalRConnection = (adapterId: string) => {
        const headers = {
            'X-Tenant-Id': localStorage.getItem('domain') as string,
            'X-User-Id': decodeJwtWithJsrs(localStorage.getItem('access_token'))?.sub,
            'X-Application': 'XSI',
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        };

        const connection = new HubConnectionBuilder()
            .withUrl(`${ADAPTERS_BASE_URL}/xsmpublish?adapterId=${adapterId}`, { headers })
            .withAutomaticReconnect()
            .build();

        connection.start().then(() => {
            connection.invoke('GetConnectionId').then(function (connectionId) {
                console.log("generalConnectionId", connectionId);
            })
        }).then(() => {
            connection.on('SendNotification', (AdapterId, ConfigureAdapterEndpointId, IsSuccess, XSMResponse) => {
                setSignalRData((prevItems: any) => [...prevItems, { AdapterId, ConfigureAdapterEndpointId, XSMResponse, IsSuccess }]);
            })
        })
            .catch(e => console.log('Connection failed: ', e));
    }


    const values = {
        signalRData,
        makeSignalRConnection
    }

    return (
        <AdapterContext.Provider value={values}>
            {children}
        </AdapterContext.Provider>
    );
}